import type { ExtractAtomValue } from 'jotai';
import { atom } from 'jotai';
import { type TaskModeT, TASK_MODE } from '../../../common/task-state/constants';
import type { validationsAtom } from './side-panel-atoms';
export const taskModeAtom = atom<TaskModeT>(TASK_MODE.EDIT);
export const readOnlyAtom = atom<boolean>(false);
export type TaskStateAtomHydrationList = [typeof readOnlyAtom, ExtractAtomValue<typeof readOnlyAtom>] | [typeof validationsAtom, ExtractAtomValue<typeof validationsAtom>];